import type { Topic } from '@tarot/shared';

/**
 * 운세 유형 아이콘 — 인라인 SVG 라인아트 (ModeIcon과 동일한 골드 라인 스타일).
 * 이모지와 달리 Android/iOS/PC 어디서나 동일하게 렌더링됨.
 * 색은 currentColor — 사용처에서 text-gold 등으로 지정.
 */
export function TopicIcon({ topic, className = 'h-8 w-8' }: { topic: Topic; className?: string }) {
  const common = {
    viewBox: '0 0 48 48',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    className,
    'aria-hidden': true,
  };

  switch (topic) {
    // 오늘의 운세 — 해
    case 'today':
      return (
        <svg {...common}>
          <circle cx="24" cy="24" r="7.5" />
          <path d="M24 10v4M24 34v4M10 24h4M34 24h4M14.1 14.1l2.8 2.8M31.1 31.1l2.8 2.8M33.9 14.1l-2.8 2.8M16.9 31.1l-2.8 2.8" />
        </svg>
      );

    // 연애 — 하트
    case 'love':
      return (
        <svg {...common}>
          <path d="M24 36c-7.2-5.3-12-9-12-14.2C12 17.6 15.2 15 18.6 15c2.2 0 4.2 1.1 5.4 3 1.2-1.9 3.2-3 5.4-3 3.4 0 6.6 2.6 6.6 6.8C36 27 31.2 30.7 24 36z" />
        </svg>
      );

    // 우정 — 나란히 선 두 사람
    case 'friendship':
      return (
        <svg {...common}>
          <circle cx="18" cy="17.5" r="4.6" />
          <circle cx="30" cy="17.5" r="4.6" />
          <path d="M9.5 35c1.2-5.2 4.4-7.9 8.5-7.9 2.3 0 4.3.9 6 2.7 1.7-1.8 3.7-2.7 6-2.7 4.1 0 7.3 2.7 8.5 7.9" />
        </svg>
      );

    // 사업 — 상승 차트
    case 'business':
      return (
        <svg {...common}>
          <path d="M11 13v22h26" />
          <path d="M16 29l6-6 4 3.5L34 18" />
          <path d="M29.5 18H34v4.5" />
        </svg>
      );

    // 학업·시험 — 펼쳐진 책
    case 'study':
      return (
        <svg {...common}>
          <path d="M24 16.5c-2.8-2.3-6.6-3.2-11-3.2v20.2c4.4 0 8.2.9 11 3.2 2.8-2.3 6.6-3.2 11-3.2V13.3c-4.4 0-8.2.9-11 3.2z" />
          <path d="M24 16.5v20.2" />
          <path d="M17 20.5c1.8.2 3.4.6 4.7 1.2M17 25.5c1.8.2 3.4.6 4.7 1.2" strokeWidth="1.4" />
        </svg>
      );

    // 결혼 — 맞물린 반지 + 다이아
    case 'marriage':
      return (
        <svg {...common}>
          <circle cx="19" cy="28" r="7" />
          <circle cx="29" cy="28" r="7" />
          <path d="M29 12.5l-3.2 4 3.2 2.8 3.2-2.8-3.2-4z" />
        </svg>
      );

    // 행운 — 네잎클로버
    case 'luck':
      return (
        <svg {...common}>
          <circle cx="24" cy="16.5" r="5" />
          <circle cx="16.5" cy="24" r="5" />
          <circle cx="31.5" cy="24" r="5" />
          <circle cx="24" cy="31.5" r="5" />
          <path d="M25.5 33.5c1 2.5 2.5 4 4.5 4.5" />
        </svg>
      );

    // 금전 — ₩ 동전
    case 'money':
      return (
        <svg {...common}>
          <circle cx="24" cy="24" r="11.5" />
          <path d="M19 19.5l2.2 9 2.8-6.5 2.8 6.5 2.2-9" />
          <path d="M18.5 24.5h11" strokeWidth="1.4" />
        </svg>
      );

    // 건강 — 새싹
    case 'health':
      return (
        <svg {...common}>
          <path d="M24 37V21" />
          <path d="M24 26c-.5-6-4.8-9.3-10.3-9.3.3 6 4.8 9.3 10.3 9.3z" />
          <path d="M24 21c.3-5.4 4.3-8.4 9.3-8.4-.3 5.4-4.3 8.4-9.3 8.4z" />
        </svg>
      );
  }
}
